import { GameConfig } from '@/config/game';
import createArrayFromNumber from '@/utilities/createArrayFromNumber';
import { splitTimeString } from '@/utilities/dateUtils';
import { DateTime, WeekdayNumbers } from 'luxon';
import { toDayNumber } from './getNextJackpot';

export default function drawRangeDate(
  weeks: number,
  drawDays: string[],
  deadlines?: GameConfig['drawDeadlines']
): number[] {
  if (!drawDays || !weeks) {
    return [];
  }
  return createArrayFromNumber(weeks, 0)
    .reduce((prev, week) => {
      const dates: number[] = drawDays.map((drawDay) => {
        try {
          const now = DateTime.now().plus({ weeks: week });
          const matchingDeadline =
            deadlines && deadlines.find((d) => d.day === drawDay);

          const dayNumber: WeekdayNumbers = toDayNumber(drawDay);
          const timeSplits = matchingDeadline
            ? splitTimeString(matchingDeadline.time)
            : [0, 0];
          const deadline = DateTime.now().set({
            weekday: dayNumber,
            hour: timeSplits[0],
            minute: timeSplits[1],
          });

          const weekday: WeekdayNumbers = <WeekdayNumbers>deadline.weekday;
          const draw = DateTime.fromMillis(now.toMillis(), {
            zone: 'Europe/Berlin',
          }).set({
            weekday: weekday,
            hour: deadline.hour,
            minute: deadline.minute,
            second: 0,
          });

          return +(draw.toMillis() <= now.toMillis()
            ? draw.plus({ weeks: 1 })
            : draw);
        } catch {
          throw new Error('Upps, da ist etwas schief gelaufen!');
        }
      });
      return [...prev, ...dates];
    }, [])
    .sort((a, b) => a - b);
}
